import React from "react";
import NetworkIndicator from "../Network";

interface P extends React.HtmlHTMLAttributes<HTMLDivElement> {
  value: number;
  size?: "small" | "normal";
}

function getLevel(value: number): 0 | 1 | 2 | 3 | 4 {
  if (value === 0) return 0;
  if (value < 0.4) return 1;
  if (value < 0.7) return 2;
  if (value < 0.9) return 3;
  return 4;
}

function ConfidenceIndicator({ className, value, size }: P) {
  return <NetworkIndicator size={size} level={getLevel(value)} className={className} />;
}

export default ConfidenceIndicator;
